import { Injectable, Pipe, PipeTransform } from '@angular/core';
import {
    EnumIdsTcEstadoSolicitud,
    EnumIdsTcTipoSolicitud,
    EnumIdsEstadoChedPP,
    EnumIdsTwTcResultadoEnvioMuestraLaboratorio,
} from 'src/app/components/_importacion/solicitudes/types/enum';
import {
    EnumIdsTcEstadoSolicitudEx,
    EnumIdsTcEstadoCertificadoFitoEx,
    EnumIdsTcTipoSolicitudEx,
    EnumIdsTwTcSubTipoSolicitudEx,
} from 'src/app/components/_exportacion/solicitudes/types/enum';
import { EnumIdsTcEstadoSolicitudAtestFito, EnumIdsTcTipoSolicitudAtestFito } from '../../../_exportacion/atestaciones/types/enum';
import { TcEstadoCopiaCFExEnum } from '../../../_exportacion/solicitudes/envio/copiaCF/copiaCFEx.types';
import { EnumIdsTcEstadoSolicitudCpe } from '../../../_exportacion/cpe/types/enum';
import { EnumIdsTcEstadoPvCam } from '../../../_campanias/types/enum';

@Pipe({
    name: 'arrayFromNumber',
    pure: false,
})
export class ArrayFromNumberPipe implements PipeTransform {
    transform(value: number, args: string[]): any {
        const res = [];
        for (let i = 0; i < value; i++) {
            res.push(i);
        }
        return res;
    }
}

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
    transform(value: string, args: string[]): string {
        const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
        const trail = args.length > 1 ? args[1] : '...';
        return value.length > limit ? value.substring(0, limit) + trail : value;
    }
}

@Pipe({ name: 'siNo' })
export class SiNoPipe implements PipeTransform {
    transform(value: boolean): string {
        return value ? 'SI' : 'NO';
    }
}

@Pipe({ name: 'tipoClonacion' })
export class TipoClonacionPipe implements PipeTransform {
    transform(value: number): string {
        return value == 1 ? 'Clonada' : value == 2 ? 'Partida' : '';
    }
}

@Pipe({ name: 'preduaNoPredua' })
export class PreduaPipe implements PipeTransform {
    transform(value: boolean): string {
        return value ? 'PREDUA' : 'NO PREDUA';
    }
}

@Pipe({ name: 'IconoTipoSolicitudEx' })
export class IconoTipoSolicitudExPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case EnumIdsTcTipoSolicitudEx.ID_TERCER_PAIS:
                return './assets/images/TipoSolicitudEx/1.png';
            case EnumIdsTcTipoSolicitudEx.ID_REEXPORTACION:
                return './assets/images/TipoSolicitudEx/2.png';
            case EnumIdsTcTipoSolicitudEx.ID_CANARIAS:
                return './assets/images/TipoSolicitudEx/3.png';
            case EnumIdsTcTipoSolicitudEx.ID_ATESTACION_FITOSANITARIA:
                return './assets/images/TipoSolicitudEx/5.png';
            case EnumIdsTcTipoSolicitudEx.ID_CAMPANIAS_ESPECIFICAS:
                return './assets/images/TipoSolicitudEx/6.png';
            default:
                return '';
        }
    }
}

@Pipe({ name: 'IconoTipoSolicitud' })
export class IconoTipoSolicitudPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case EnumIdsTcTipoSolicitud.ID_NORMAL:
                return './assets/images/TipoSolicitud/1.png';
            case EnumIdsTcTipoSolicitud.ID_TRASLADO:
                return './assets/images/TipoSolicitud/2.png';
            case EnumIdsTcTipoSolicitud.ID_FINES_CIENTIFICOS:
                return './assets/images/TipoSolicitud/3.png';
            case EnumIdsTcTipoSolicitud.ID_ORG_CONTROL_BIOLOGICO:
                return './assets/images/TipoSolicitud/4.png';
            case EnumIdsTcTipoSolicitud.ID_CANARIAS:
                return './assets/images/TipoSolicitud/5.png';
            case EnumIdsTcTipoSolicitud.ID_TRANSITO_DIRECTO:
                return './assets/images/TipoSolicitud/6.png';
            case EnumIdsTcTipoSolicitud.ID_PASAJEROS:
                return './assets/images/TipoSolicitud/7.png';
            case EnumIdsTcTipoSolicitud.ID_TRANSBORDO:
                return './assets/images/TipoSolicitud/8.png';
            case EnumIdsTcTipoSolicitud.ID_PROD_FITOSANITARIOS:
                return './assets/images/TipoSolicitud/9.png';
            default:
                return '';
        }
    }
}

@Pipe({ name: 'IconoTipoSolicitudAtest' })
export class IconoTipoSolicitudAtestPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case EnumIdsTcTipoSolicitudAtestFito.ID_COMUNIDAD_AUTONOMA:
                return './assets/images/TipoSolicitudAtestFito/1.png';
            case EnumIdsTcTipoSolicitudAtestFito.ID_AGENTE_CONTROL:
                return './assets/images/TipoSolicitudAtestFito/2.png';
            default:
                return '';
        }
    }
}

@Pipe({ name: 'IconoEstadoSolicitud' })
export class IconoEstadoSolicitudPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case EnumIdsTcEstadoSolicitud.ID_BORRADOR:
                return './assets/images/EstadoSolicitud/1.png';
            case EnumIdsTcEstadoSolicitud.ID_NUEVA:
                return './assets/images/EstadoSolicitud/2.png';
            case EnumIdsTcEstadoSolicitud.ID_FINALIZADA_CONFORME:
                return './assets/images/EstadoSolicitud/3.png';
            case EnumIdsTcEstadoSolicitud.ID_RECHAZADA_INSPECTOR:
                return './assets/images/EstadoSolicitud/4.png';
            case EnumIdsTcEstadoSolicitud.ID_EN_TRAMITE:
                return './assets/images/EstadoSolicitud/5.png';
            case EnumIdsTcEstadoSolicitud.ID_ANULADA:
                return './assets/images/EstadoSolicitud/6.png';
            case EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA:
                return './assets/images/EstadoSolicitud/7.png';
            case EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE:
                return './assets/images/EstadoSolicitud/8.png';
            case EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE:
                return './assets/images/EstadoSolicitud/9.png';
            case EnumIdsTcEstadoSolicitud.ID_PENDIENTE_TRACES:
                return './assets/images/EstadoSolicitud/10.png';
            case EnumIdsTcEstadoSolicitud.ID_RECHAZADA_TRACES:
                return './assets/images/EstadoSolicitud/11.png';
            case EnumIdsTcEstadoSolicitud.ID_PENDIENTE_ADUANAS:
                return './assets/images/EstadoSolicitud/12.png';
            case EnumIdsTcEstadoSolicitud.ID_RECHAZADA_ADUANAS:
                return './assets/images/EstadoSolicitud/13.png';
            case EnumIdsTcEstadoSolicitud.ID_REVISADO_SOLICITANTE:
                return './assets/images/EstadoSolicitud/14.png';
            case EnumIdsTcEstadoSolicitud.ID_RECHAZADA_PARCIALMENTE:
                return './assets/images/EstadoSolicitud/15.png';
            case EnumIdsTcEstadoSolicitud.ID_RECHAZADA_HIGIENE:
                return './assets/images/EstadoSolicitud/16.png';
            default:
                return './assets/images/EstadoSolicitud/0.png';
        }
    }
}

@Pipe({ name: 'IconoEstadoSolicitudAtest' })
export class IconoEstadoSolicitudAtestPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case EnumIdsTcEstadoSolicitudAtestFito.ID_BORRADOR:
                return './assets/images/EstadoSolicitud/1.png';
            case EnumIdsTcEstadoSolicitudAtestFito.ID_NUEVA:
                return './assets/images/EstadoSolicitud/2.png';
            case EnumIdsTcEstadoSolicitudAtestFito.ID_CONFORME:
                return './assets/images/EstadoSolicitud/3.png';
            case EnumIdsTcEstadoSolicitudAtestFito.ID_NO_CONFORME: //lo mismo que rechazada por inspector
                return './assets/images/EstadoSolicitud/4.png';

            case EnumIdsTcEstadoSolicitudAtestFito.ID_ANULADA:
                return './assets/images/EstadoSolicitud/6.png';

            default:
                return './assets/images/EstadoSolicitud/0.png';
        }
    }
}

@Pipe({ name: 'IconoEstadoSolicitudCpe' })
export class IconoEstadoSolicitudCpePipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case EnumIdsTcEstadoSolicitudCpe.ID_BORRADOR:
                return './assets/images/EstadoSolicitud/1.png';
            case EnumIdsTcEstadoSolicitudCpe.ID_NUEVA:
                return './assets/images/EstadoSolicitud/2.png';
            case EnumIdsTcEstadoSolicitudCpe.ID_CONFORME:
                return './assets/images/EstadoSolicitud/3.png';
            case EnumIdsTcEstadoSolicitudCpe.ID_NO_CONFORME:
                return './assets/images/EstadoSolicitud/4.png';
            case EnumIdsTcEstadoSolicitudCpe.ID_EN_TRAMITE:
                return './assets/images/EstadoSolicitud/5.png';
            case EnumIdsTcEstadoSolicitudCpe.ID_ANULADA:
                return './assets/images/EstadoSolicitud/6.png';
            case EnumIdsTcEstadoSolicitudCpe.ID_REVISION_SOLICITANTE:
                return './assets/images/EstadoSolicitud/9.png';

            default:
                return './assets/images/EstadoSolicitud/0.png';
        }
    }
}

@Pipe({ name: 'IconoEstadoSolicitudEx' })
export class IconoEstadoSolicitudExPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case EnumIdsTcEstadoSolicitudEx.ID_BORRADOR:
                return './assets/images/EstadoSolicitud/EstadoSolicitudExport/1.png';
            case EnumIdsTcEstadoSolicitudEx.ID_NUEVA:
                return './assets/images/EstadoSolicitud/EstadoSolicitudExport/2.png';
            case EnumIdsTcEstadoSolicitudEx.ID_FINALIZADA_CONFORME:
                return './assets/images/EstadoSolicitud/EstadoSolicitudExport/3.png';
            case EnumIdsTcEstadoSolicitudEx.ID_RECHAZADA_INSPECTOR:
                return './assets/images/EstadoSolicitud/EstadoSolicitudExport/4.png';
            case EnumIdsTcEstadoSolicitudEx.ID_EN_TRAMITE:
                return './assets/images/EstadoSolicitud/EstadoSolicitudExport/5.png';
            case EnumIdsTcEstadoSolicitudEx.ID_ANULADA:
                return './assets/images/EstadoSolicitud/EstadoSolicitudExport/6.png';
            case EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA:
                return './assets/images/EstadoSolicitud/EstadoSolicitudExport/7.png';
            case EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE:
                return './assets/images/EstadoSolicitud/EstadoSolicitudExport/8.png';
            case EnumIdsTcEstadoSolicitudEx.ID_REVISION_SOLICITANTE:
                return './assets/images/EstadoSolicitud/EstadoSolicitudExport/9.png';
            case EnumIdsTcEstadoSolicitudEx.ID_REVISADO_SOLICITANTE:
                return './assets/images/EstadoSolicitud/EstadoSolicitudExport/10.png';
            case EnumIdsTcEstadoSolicitudEx.ID_AVISO_CONFECCION:
                return './assets/images/EstadoSolicitud/EstadoSolicitudExport/11.png';

            default:
                return './assets/images/EstadoSolicitud/EstadoSolicitudExport/0.png';
        }
    }
}

@Pipe({ name: 'IconoEstadoPv' })
export class IconoEstadoPvPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case EnumIdsTcEstadoPvCam.ID_NO_PRESENTADO:
                return './assets/images/EstadoSolicitud/EstadoPvCam/1.png';
            case EnumIdsTcEstadoPvCam.ID_PRESENTADO:
                return './assets/images/EstadoSolicitud/EstadoPvCam/2.png';
            case EnumIdsTcEstadoPvCam.ID_DEVUELTO:
                return './assets/images/EstadoSolicitud/EstadoPvCam/3.png';
            case EnumIdsTcEstadoPvCam.ID_ACEPTADO:
                return './assets/images/EstadoSolicitud/EstadoPvCam/4.png';
            case EnumIdsTcEstadoPvCam.ID_RECHAZADO:
                return './assets/images/EstadoSolicitud/EstadoPvCam/5.png';

            default:
                return './assets/images/EstadoSolicitud/EstadoPvCam/0.png';
        }
    }
}

@Pipe({ name: 'IconoEstadoCertificadoFitoEx' })
export class IconoEstadoCertificadoFitoEx implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case EnumIdsTcEstadoCertificadoFitoEx.ID_PENDIENTE:
                return './assets/images/EstadoCertificadoFitoEx/1.png';
            case EnumIdsTcEstadoCertificadoFitoEx.ID_FINALIZADO_CONFORME:
                return './assets/images/EstadoCertificadoFitoEx/2.png';
            case EnumIdsTcEstadoCertificadoFitoEx.ID_ANULADO:
                return './assets/images/EstadoCertificadoFitoEx/3.png';
            case EnumIdsTcEstadoCertificadoFitoEx.ID_ANULADO_SUSTITUIDO:
                return './assets/images/EstadoCertificadoFitoEx/4.png';
            case EnumIdsTcEstadoCertificadoFitoEx.ID_RECHAZADO_EPHYTO:
                return './assets/images/EstadoCertificadoFitoEx/5.png';
            case EnumIdsTcEstadoCertificadoFitoEx.ID_ENVIADA_EPHYTO:
                return './assets/images/EstadoCertificadoFitoEx/6.png';
            case EnumIdsTcEstadoCertificadoFitoEx.ID_ENVIADA_ANULACION_EPHYTO:
                return './assets/images/EstadoCertificadoFitoEx/7.png';
            case EnumIdsTcEstadoCertificadoFitoEx.ID_ENVIADA_ANULACION_SUSTITUCION_EPHYTO:
                return './assets/images/EstadoCertificadoFitoEx/8.png';

            default:
                return './assets/images/EstadoCertificadoFitoEx/0.png';
        }
    }
}
@Pipe({ name: 'IconoEstadoChedPP' })
export class IconoEstadoChedPPPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case EnumIdsEstadoChedPP.ID_PENDIENTE:
                return './assets/images/EstadoChedPP/1.png';
            case EnumIdsEstadoChedPP.ID_FINALIZADO_CONFORME:
                return './assets/images/EstadoChedPP/2.png';
            case EnumIdsEstadoChedPP.ID_RECHAZADO:
                return './assets/images/EstadoChedPP/3.png';
            case EnumIdsEstadoChedPP.ID_ANULADO:
                return './assets/images/EstadoChedPP/4.png';
            case EnumIdsEstadoChedPP.ID_NO_PROCEDE:
                return './assets/images/EstadoChedPP/5.png';

            default:
                return './assets/images/EstadoChedPP/0.png';
        }
    }
}

@Pipe({ name: 'IconoCopiaCertificadoEx' })
export class IconoCopiaCertificadoExPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case TcEstadoCopiaCFExEnum.Nueva:
                return './assets/images/Copia/Nueva.png';
            case TcEstadoCopiaCFExEnum.Conforme:
                return './assets/images/Copia/Conforme.png';
            case TcEstadoCopiaCFExEnum.NoConforme:
                return './assets/images/Copia/NoConforme.png';
            case TcEstadoCopiaCFExEnum.Anulada:
                return './assets/images/Copia/Anulada.png';

            default:
                return './assets/images/Copia/Nueva.png';
        }
    }
}

@Pipe({ name: 'IconoPreduaSolicitud' })
export class IconoPreduaSolicitudPipe implements PipeTransform {
    transform(value: boolean): string {
        if (value) {
            return './assets/images/EstadoSolicitud/PreduaSI.png';
        } else {
            return './assets/images/EstadoSolicitud/PreduaNO.png';
        }
    }
}

@Pipe({ name: 'IconoCheckEnvio' })
export class IconoCheckEnvioPipe implements PipeTransform {
    transform(value: boolean): string {
        //if (value) {
        //    return "./assets/images/Check.png";
        //}
        //else {
        //    return "./assets/images/Atencion.png";
        //}
        switch (value) {
            case true:
                return './assets/images/Check.png';
            case false:
                return './assets/images/Atencion.png';
            default:
                return '';
        }
    }
}

@Pipe({ name: 'IconoSolicitudAsignada' })
export class IconoSolicitudAsignadaPipe implements PipeTransform {
    transform(value: number): string {
        if (value || value > 0) {
            return './assets/images/EstadoSolicitud/Tipo.png';
        } else {
            return './assets/images/EstadoSolicitud/TipoNoasig.png';
        }
    }
}

//@adua 11/09/2020 no hay sporte para bigint
@Pipe({ name: 'IconoDocumentoTraces' })
export class IconoDocumentoTracesPipe implements PipeTransform {
    transform(value: string): [string, string] {
        //if (value) {
        switch (value) {
            case '9999999':
                return ['./assets/images/DocTraces/TracesDownload.png', 'Documento descargado de TRACES'];
            case '':
                return ['./assets/images/DocTraces/TracesError.png', 'Error documento en TRACES'];
            default:
                return ['./assets/images/DocTraces/TracesOK.png', 'Documento añadido en TRACES'];
        }
        //}
        //else {
        //    return ["", ""];
        //}
    }
}

@Pipe({ name: 'IconoDocumentoExTraces' })
export class IconoDocumentoExTracesPipe implements PipeTransform {
    transform(value: boolean, args: string): [any, any] {
        const field = args[0];
        const esEphyto = args.length > 1 ? args[1] : false;

        switch (field) {
            case 'Autogenerado':
                if (value && esEphyto) {
                    return ['./assets/images/DocTraces/TracesDownload.png', 'Documento descargado de TRACES'];
                } else {
                    //return [null, ''];
                    return ['./assets/images/DocTraces/SedeDownload.png', 'Documento en Sede Electrónica del MAPA'];
                }
            case 'AttachedEphyto':
                if (value) {
                    return ['./assets/images/DocTraces/TracesOK.png', 'Documento adjuntado al ePhyto'];
                } else {
                    return [null, ''];
                }
            default:
                return [null, ''];
        }
    }
}

@Pipe({ name: 'IconoResultadoEnvioMuestraLaboratorio' })
export class IconoResultadoEnvioMuestraLaboratorioPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case EnumIdsTwTcResultadoEnvioMuestraLaboratorio.ID_PENDIENTE:
                return './assets/images/ResultadoEnvioMuestrasLaboratorio/1.png';
            case EnumIdsTwTcResultadoEnvioMuestraLaboratorio.ID_ACEPTADA:
                return './assets/images/ResultadoEnvioMuestrasLaboratorio/2.png';
            case EnumIdsTwTcResultadoEnvioMuestraLaboratorio.ID_RECHAZADA:
                return './assets/images/ResultadoEnvioMuestrasLaboratorio/3.png';
            default:
                return '';
        }
    }
}

@Pipe({ name: 'IconoTwTcSubTipoSolicitudEx' })
export class IconoTwTcSubTipoSolicitudExPipe implements PipeTransform {
    transform(value: number): string {
        switch (value) {
            case EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO:
                return './assets/images/SubTipoSolicitudEx/Tiene_atestacion_fitosanitaria.png';
            case EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO:
                return './assets/images/SubTipoSolicitudEx/Tiene_atestacion_fitosanitaria.png';
            case EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO:
                return './assets/images/SubTipoSolicitudEx/Tiene_atestacion_fitosanitaria.png';
            default:
                return '';
        }
    }
}

@Pipe({ name: 'IconoProdsEmbsRp' })
export class IconoProdsEmbsRpPipe implements PipeTransform {
    transform(): string {
        return './assets/images/prods-embs-rp.png';
    }
}

@Pipe({ name: 'IconoProdsEmbsRpAceptado' })
export class IconoProdsEmbsRpAceptadoPipe implements PipeTransform {
    transform(value: boolean): string {
        if (value) {
            return './assets/images/Aceptado.png';
        } else {
            return './assets/images/NO_Aceptado.png';
        }
    }
}

@Pipe({ name: 'MonthNumberToString' })
export class MonthNumberToStringPipe implements PipeTransform {
    transform(value: number): string {
        if (value == null) {
            return '';
        }

        switch (value) {
            case 1:
                return 'Enero';
            case 2:
                return 'Febrero';
            case 3:
                return 'Marzo';
            case 4:
                return 'Abril';
            case 5:
                return 'Mayo';
            case 6:
                return 'Junio';
            case 7:
                return 'Julio';
            case 8:
                return 'Agosto';
            case 9:
                return 'Septiembre';
            case 10:
                return 'Octubre';
            case 11:
                return 'Noviembre';
            case 12:
                return 'Diciembre';

            default:
                return '';
        }
    }
}

@Pipe({ name: 'MonthStringNumberToString' })
@Injectable({
    providedIn: 'root', // Hace que esté disponible globalmente
})
export class MonthStringNumberToStringPipe implements PipeTransform {
    transform(value: string): string {
        if (value == null) {
            return '';
        }

        switch (value) {
            case '01':
                return 'enero';
            case '02':
                return 'febrero';
            case '03':
                return 'marzo';
            case '04':
                return 'abril';
            case '05':
                return 'mayo';
            case '06':
                return 'junio';
            case '07':
                return 'julio';
            case '08':
                return 'agosto';
            case '09':
                return 'septiembre';
            case '10':
                return 'octubre';
            case '11':
                return 'noviembre';
            case '12':
                return 'diciembre';

            default:
                return '';
        }
    }
}

@Pipe({ name: 'MonthStringToNumber' })
@Injectable({
    providedIn: 'root', // Hace que esté disponible globalmente
})
export class MonthStringToNumberPipe implements PipeTransform {
    transform(value: string): number | null {
        if (value == '') {
            return null;
        }

        switch (value) {
            case 'Enero':
                return 1;
            case 'Febrero':
                return 2;
            case 'Marzo':
                return 3;
            case 'Abril':
                return 4;
            case 'Mayo':
                return 5;
            case 'Junio':
                return 6;
            case 'Julio':
                return 7;
            case 'Agosto':
                return 8;
            case 'Septiembre':
                return 9;
            case 'Octubre':
                return 10;
            case 'Noviembre':
                return 11;
            case 'Diciembre':
                return 12;

            default:
                return null;
        }
    }
}

@Pipe({ name: 'MonthStringToStringNumber' })
@Injectable({
    providedIn: 'root', // Hace que esté disponible globalmente
})
export class MonthStringToStringNumberPipe implements PipeTransform {
    transform(value: string): string | null {
        if (value == '') {
            return '';
        }

        switch (value) {
            case 'Enero':
                return '01';
            case 'Febrero':
                return '02';
            case 'Marzo':
                return '03';
            case 'Abril':
                return '04';
            case 'Mayo':
                return '05';
            case 'Junio':
                return '06';
            case 'Julio':
                return '07';
            case 'Agosto':
                return '08';
            case 'Septiembre':
                return '09';
            case 'Octubre':
                return '10';
            case 'Noviembre':
                return '11';
            case 'Diciembre':
                return '12';

            default:
                return '';
        }
    }
}
